var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"package_for_choose_component-wrap"},[_vm._t("default"),(_vm.canEditPackage)?_c('img',{staticClass:"min-title-close",attrs:{"alt":"x","src":require("../../../../public/icon/newStanard/关闭备份2.png")},on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }